import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';
import {AppSettings} from '../app-settings';
import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class PageService {

  public token: string;

  headers = new Headers({'Accept': 'application/json'});
  options = new RequestOptions({headers: this.headers});

  constructor(private http: Http, private authHttp: AuthHttp) {
   var currentUser = JSON.parse(localStorage.getItem('currentUser'));
   this.token = currentUser && currentUser.token;
  }

  getPages(eventId): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/page/get",{
    params : {
     eventId:eventId
    }
   }).map(response => response.json().pages);
  }

  findPage(pageId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/page/find",{
    params : {
     id:pageId
    }
   }).map(response => response.json().page);
  }

  findGlobalPage(pageId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/globalpage/find",{
    params : {
     id:pageId
    }
   }).map(response => response.json().page);
  }

  savePage(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/page/"+(params.id?'edit':'add'), params, this.options).map(response => response.json());
  }  


  saveGlobalPage(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/globalpage/"+(params.id?'edit':'add'), params, this.options).map(response => response.json());
  }

  deletePage(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/page/delete", params, this.options).map(response => response.json());
  }

  deleteGlobalPage(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/globalpage/delete", params, this.options).map(response => response.json());
  }

  getGlobalPages(): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/globalpage/get",{
    params : {
     
    }
   }).map(response => response.json().pages);
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/common/page.service.ts